import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  connect() {
    // Make sure password is hidden by default
    if (this.hasInputTarget) {
      this.inputTarget.type = "password"
    }
    
    // Initially show the "show" icon and hide the "hide" icon
    if (this.hasShowIconTarget && this.hasHideIconTarget) {
      this.showIconTarget.classList.remove("hidden")
      this.hideIconTarget.classList.add("hidden")
    }
  }

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      this.showIconTarget.classList.add("hidden")
      this.hideIconTarget.classList.remove("hidden")
    } else {
      this.inputTarget.type = "password"
      this.showIconTarget.classList.remove("hidden")
      this.hideIconTarget.classList.add("hidden")
    }
  }
} 